const DEFAULTS = {
    threshold: 2,
    matchValue: false,
    maximumItems: 5,
    highlightTyped: true,
    highlightClass: 'text-primary',
    label: 'label',
    value: 'value',
    renderValue: function (v) { return v; },
    showOnFocus: false,
    showValue: false,
    showValueBeforeLabel: false,
};

class Autocomplete {
    constructor(field, options) {
        this.created = false;
        this.field = field;
        this.options = Object.assign({}, DEFAULTS, options);
        this.dropdown = null;
        this.autofocus = null;
        this.itemHighlighted = null;

        field.parentNode.classList.add('dropdown');
        field.setAttribute('data-bs-toggle', 'dropdown');
        field.classList.add('dropdown-toggle');

        const dropdown = ce(`<div class="dropdown-menu"></div>`);
        if (this.options.dropdownClass)
            dropdown.classList.add(this.options.dropdownClass);

        insertAfter(dropdown, field);

        this.dropdown = new bootstrap.Dropdown(field, this.options.dropdownOptions);

        field.addEventListener('click', (e) => {
            if (!this.created && this.createItems() === 0) {
                e.stopPropagation();
                this.hide();
            }
        });

        field.addEventListener('focus', (e) => {
            const self = this;
            if (this.options.showOnFocus) {
                setTimeout(() => {
                     if (self.isHidden())
                        self.renderIfNeeded(true);
                }, 100)
            }
        });

        field.addEventListener('input', (e) => {
            if (this.options.onInput)
                this.options.onInput(this.field.value, e);
            else if (!e.detail || !e.detail.selected)
                this.renderIfNeeded();
        });

        field.addEventListener('keydown', (e) => {
            if (e.keyCode === 27) {
                this.hide();
                return;
            }
            if (e.keyCode === 40) {
                this.dropdown?._menu.children[0]?.focus();
                return;
            }
            if (e.key.toUpperCase() === 'ENTER') {
                if (this.options.itemHighlighted) {
                    this.options.onSelectItem && this.options.onSelectItem(this.options.itemHighlighted);
                    this.hide();
                }
                return;
            }
        });

        field.addEventListener('blur', (e) => {
            let self = this;
            setTimeout(() => {
                var item = self.dropdown._menu.children[0];
                if (item && !self.isHidden()) {
                    let dataLabel = item.getAttribute('data-label');
                    self.field.value = dataLabel;
                }
                if (item != document.activeElement) {
                    self.dropdown.hide();
                }
            }, 100);
        });
    }

    isHidden() {
        var style = window.getComputedStyle(this.dropdown._menu);
        return (style.display === 'none') || (this.dropdown._menu.offsetParent == null);
    }

    hide() { this.dropdown?.hide(); }

    show() {
        this.dropdown?.show();
        window.dispatchEvent(new CustomEvent('scroll'));
    }

    setData(data, allmatch) {
        this.options.data = data;
        this.renderIfNeeded(allmatch);
    }

    renderIfNeeded(allmatch) {
        if (this.createItems(allmatch) > 0) {
            this.show();
        } else {
            this.created = true;
            this.autofocus && this.field.click();
            this.autofocus = true;
            this.created = false;
            if (this.field.nextSibling.childNodes.length > 0) {
                this.show();
            }
        }
    }

    createItem(lookup, item) {
        var label;
        if (this.options.highlightTyped) {
            const idx = removeDiacritics(item.label)
                .toLowerCase()
                .indexOf(removeDiacritics(lookup).toLowerCase());
            if (idx >= 0) {
                const className = Array.isArray(this.options.highlightClass) ? this.options.highlightClass.join(' ')
                    : (typeof this.options.highlightClass == 'string' ? this.options.highlightClass : '');
                label = item.label.substring(0, idx)
                    + `<span class="${className}">${item.label.substring(idx, idx + lookup.length)}</span>`
                    + item.label.substring(idx + lookup.length, item.label.length);
            } else {
                label = item.label;
            }
        } else {
            label = item.label;
        }

        if (this.options.showValue) {
            if (this.options.showValueBeforeLabel) {
                label = `${this.options.renderValue(item.value)} ${label}`;
            } else {
                label += ` ${this.options.renderValue(item.value)}`;
            }
        }

        let elem = ce('<button type="button" class="dropdown-item"></button>');
        elem.setAttribute('data-label', item.label);
        elem.setAttribute('data-value', item.value);
        elem.setAttribute('data-url', item.url);
        elem.setAttribute('data-id', item.id);
        elem.innerHTML = label;
        return elem;
    }

    createItems(allmatch) {
        const lookup = this.field.value;
        const matchall = allmatch || this.options.matchall;
        if (lookup.length < this.options.threshold && !this.options.showOnFocus) {
            this.hide();
            return 0;
        }

        const items = this.field.nextSibling;
        let existing = [...items.children];

        const keys = Object.keys(this.options.data || {});

        function matches(item, matchValue, search) {
            return matchall || removeDiacritics(item.label).toLowerCase().indexOf(search) >= 0 ||
                (matchValue && removeDiacritics(`${item.value}`).toLowerCase().indexOf(search) >= 0);
        }

        let count = 0;
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const entry = this.options.data[key];
            const item = Object.assign({
                label: this.options.label ? entry[this.options.label] : key,
                value: this.options.value ? entry[this.options.value] : entry
            }, entry);

            if (matches(item, this.matchValue, removeDiacritics(lookup).toLowerCase())) {
                items.appendChild(this.createItem(lookup, item));
                if (this.options.maximumItems > 0 && ++count >= this.options.maximumItems)
                    break;
            }
        }

        while (existing.length) {
            items.removeChild(existing.shift());
        }

        items.querySelectorAll('.dropdown-item').forEach((item) => {
            item.addEventListener('click', (e) => {
                let dataLabel = e.currentTarget.getAttribute('data-label');
                let dataValue = e.currentTarget.getAttribute('data-value');
                let dataUrl = e.currentTarget.getAttribute('data-url');
                let dataId = e.currentTarget.getAttribute('data-id');

                this.field.value = dataLabel;

                if (this.options.onSelectItem) {
                    this.options.onSelectItem({
                        value: dataValue,
                        label: dataLabel,
                        url: dataUrl,
                        id: dataId
                    });
                }

                this.hide();
            })
        });
        return items.childNodes.length;
    }
}

/**
 * @param html
 * @returns {Node}
 */
function ce(html) {
    let div = document.createElement('div');
    div.innerHTML = html;
    return div.firstChild;
}

/**
 * @param elem
 * @param refElem
 * @returns {*}
 */
function insertAfter(elem, refElem) {
    return refElem.parentNode.insertBefore(elem, refElem.nextSibling);
}

/**
 * @param {String} str
 * @returns {String}
 */
function removeDiacritics(str) {
    return (str ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
}

function createCountryAutocomplete(el, vnode) {
    const ac = new Autocomplete(el, {
        maximumItems: 5,
        threshold: 1,
        onInput: function (value) {
            let self = this;
            if (event.inputType?.startsWith('delete')) { return; }
            if (event.detail && event.detail.selected) { return; }
            let i = value.length;
            let lcase = value.toLowerCase();
            var v = this.data.find(e => {
                return e[this.label].toLowerCase().indexOf(lcase) == 0;
            }, this);
            if (v) {
                let text = v[this.label];
                window.requestAnimationFrame(() => {
                    el.value = text;
                    el.setSelectionRange(i, text.length, 'backward');
                    self.itemHighlighted = v;
                });
            }
        },
        onSelectItem: function (item) {
            vnode.elm.value = item[this.label];
            vnode.elm.dispatchEvent(new CustomEvent('input', { detail: { value: vnode.elm.value, selected: true } }));
        },
    });

    ac.setData([
        ['United States of America', 'US'],
        ['Afghanistan', 'AF'],
        ['Albania', 'AL'],
        ['Algeria', 'DZ'],
        ['American Samoa', 'AS'],
        ['Andorra', 'AD'],
        ['Angola', 'AO'],
        ['Anguilla', 'AI'],
        ['Antarctica', 'AQ'],
        ['Antigua and Barbuda', 'AG'],
        ['Argentina', 'AR'],
        ['Armenia', 'AM'],
        ['Aruba', 'AW'],
        ['Australia', 'AU'],
        ['Austria', 'AT'],
        ['Azerbaijan', 'AZ'],
        ['Bahamas', 'BS'],
        ['Bahrain', 'BH'],
        ['Bangladesh', 'BD'],
        ['Barbados', 'BB'],
        ['Belarus', 'BY'],
        ['Belgium', 'BE'],
        ['Belize', 'BZ'],
        ['Benin', 'BJ'],
        ['Bermuda', 'BM'],
        ['Bhutan', 'BT'],
        ['Bolivia', 'BO'],
        ['Bonaire, Sint Eustatius and Saba', 'BQ'],
        ['Bosnia and Herzegovina', 'BA'],
        ['Botswana', 'BW'],
        ['Bouvet Island', 'BV'],
        ['Brazil', 'BR'],
        ['British Indian Ocean Territory', 'IO'],
        ['Brunei Darussalam', 'BN'],
        ['Bulgaria', 'BG'],
        ['Burkina Faso', 'BF'],
        ['Burundi', 'BI'],
        ['Cabo Verde', 'CV'],
        ['Cambodia', 'KH'],
        ['Cameroon', 'CM'],
        ['Canada', 'CA'],
        ['Cayman Islands', 'KY'],
        ['Central African Republic', 'CF'],
        ['Chad', 'TD'],
        ['Chile', 'CL'],
        ['China', 'CN'],
        ['Christmas Island', 'CX'],
        ['Cocos (Keeling) Islands', 'CC'],
        ['Colombia', 'CO'],
        ['Comoros', 'KM'],
        ['Congo (Democratic Republic of the)', 'CD'],
        ['Congo', 'CG'],
        ['Cook Islands', 'CK'],
        ['Costa Rica', 'CR'],
        ['Croatia', 'HR'],
        ['Cuba', 'CU'],
        ['Cura\u00e7ao', 'CW'],
        ['Cyprus', 'CY'],
        ['Czechia', 'CZ'],
        ['C\u00f4te d\'Ivoire', 'CI'],
        ['Denmark', 'DK'],
        ['Djibouti', 'DJ'],
        ['Dominica', 'DM'],
        ['Dominican Republic', 'DO'],
        ['Ecuador', 'EC'],
        ['Egypt', 'EG'],
        ['El Salvador', 'SV'],
        ['Equatorial Guinea', 'GQ'],
        ['Eritrea', 'ER'],
        ['Estonia', 'EE'],
        ['Eswatini', 'SZ'],
        ['Ethiopia', 'ET'],
        ['Falkland Islands [Malvinas]', 'FK'],
        ['Faroe Islands', 'FO'],
        ['Fiji', 'FJ'],
        ['Finland', 'FI'],
        ['France', 'FR'],
        ['French Guiana', 'GF'],
        ['French Polynesia', 'PF'],
        ['French Southern Territories', 'TF'],
        ['Gabon', 'GA'],
        ['Gambia', 'GM'],
        ['Georgia', 'GE'],
        ['Germany', 'DE'],
        ['Ghana', 'GH'],
        ['Gibraltar', 'GI'],
        ['Greece', 'GR'],
        ['Greenland', 'GL'],
        ['Grenada', 'GD'],
        ['Guadeloupe', 'GP'],
        ['Guam', 'GU'],
        ['Guatemala', 'GT'],
        ['Guernsey', 'GG'],
        ['Guinea', 'GN'],
        ['Guinea-Bissau', 'GW'],
        ['Guyana', 'GY'],
        ['Haiti', 'HT'],
        ['Heard Island and McDonald Islands', 'HM'],
        ['Holy See', 'VA'],
        ['Honduras', 'HN'],
        ['Hong Kong', 'HK'],
        ['Hungary', 'HU'],
        ['Iceland', 'IS'],
        ['India', 'IN'],
        ['Indonesia', 'ID'],
        ['Iran', 'IR'],
        ['Iraq', 'IQ'],
        ['Ireland', 'IE'],
        ['Isle of Man', 'IM'],
        ['Israel', 'IL'],
        ['Italy', 'IT'],
        ['Jamaica', 'JM'],
        ['Japan', 'JP'],
        ['Jersey', 'JE'],
        ['Jordan', 'JO'],
        ['Kazakhstan', 'KZ'],
        ['Kenya', 'KE'],
        ['Kiribati', 'KI'],
        ['Korea (the Democratic People\'s Republic of)', 'KP'],
        ['Korea (the Republic of)', 'KR'],
        ['Kuwait', 'KW'],
        ['Kyrgyzstan', 'KG'],
        ['Lao People\'s Democratic Republic', 'LA'],
        ['Latvia', 'LV'],
        ['Lebanon', 'LB'],
        ['Lesotho', 'LS'],
        ['Liberia', 'LR'],
        ['Libya', 'LY'],
        ['Liechtenstein', 'LI'],
        ['Lithuania', 'LT'],
        ['Luxembourg', 'LU'],
        ['Macao', 'MO'],
        ['Madagascar', 'MG'],
        ['Malawi', 'MW'],
        ['Malaysia', 'MY'],
        ['Maldives', 'MV'],
        ['Mali', 'ML'],
        ['Malta', 'MT'],
        ['Marshall Islands', 'MH'],
        ['Martinique', 'MQ'],
        ['Mauritania', 'MR'],
        ['Mauritius', 'MU'],
        ['Mayotte', 'YT'],
        ['Mexico', 'MX'],
        ['Micronesia (Federated States of)', 'FM'],
        ['Moldova', 'MD'],
        ['Monaco', 'MC'],
        ['Mongolia', 'MN'],
        ['Montenegro', 'ME'],
        ['Montserrat', 'MS'],
        ['Morocco', 'MA'],
        ['Mozambique', 'MZ'],
        ['Myanmar', 'MM'],
        ['Namibia', 'NA'],
        ['Nauru', 'NR'],
        ['Nepal', 'NP'],
        ['Netherlands', 'NL'],
        ['New Caledonia', 'NC'],
        ['New Zealand', 'NZ'],
        ['Nicaragua', 'NI'],
        ['Niger', 'NE'],
        ['Nigeria', 'NG'],
        ['Niue', 'NU'],
        ['Norfolk Island', 'NF'],
        ['Northern Mariana Islands', 'MP'],
        ['Norway', 'NO'],
        ['Oman', 'OM'],
        ['Pakistan', 'PK'],
        ['Palau', 'PW'],
        ['Palestine, State of', 'PS'],
        ['Panama', 'PA'],
        ['Papua New Guinea', 'PG'],
        ['Paraguay', 'PY'],
        ['Peru', 'PE'],
        ['Philippines', 'PH'],
        ['Pitcairn', 'PN'],
        ['Poland', 'PL'],
        ['Portugal', 'PT'],
        ['Puerto Rico', 'PR'],
        ['Qatar', 'QA'],
        ['Republic of North Macedonia', 'MK'],
        ['Romania', 'RO'],
        ['Russian Federation', 'RU'],
        ['Rwanda', 'RW'],
        ['R\u00e9union', 'RE'],
        ['Saint Barth\u00e9lemy', 'BL'],
        ['Saint Helena, Ascension and Tristan da Cunha', 'SH'],
        ['Saint Kitts and Nevis', 'KN'],
        ['Saint Lucia', 'LC'],
        ['Saint Martin', 'MF'],
        ['Saint Pierre and Miquelon', 'PM'],
        ['Saint Vincent and the Grenadines', 'VC'],
        ['Samoa', 'WS'],
        ['San Marino', 'SM'],
        ['Sao Tome and Principe', 'ST'],
        ['Saudi Arabia', 'SA'],
        ['Senegal', 'SN'],
        ['Serbia', 'RS'],
        ['Seychelles', 'SC'],
        ['Sierra Leone', 'SL'],
        ['Singapore', 'SG'],
        ['Sint Maarten', 'SX'],
        ['Slovakia', 'SK'],
        ['Slovenia', 'SI'],
        ['Solomon Islands', 'SB'],
        ['Somalia', 'SO'],
        ['South Africa', 'ZA'],
        ['South Georgia and the South Sandwich Islands', 'GS'],
        ['South Sudan', 'SS'],
        ['Spain', 'ES'],
        ['Sri Lanka', 'LK'],
        ['Sudan', 'SD'],
        ['Suriname', 'SR'],
        ['Svalbard and Jan Mayen', 'SJ'],
        ['Sweden', 'SE'],
        ['Switzerland', 'CH'],
        ['Syrian Arab Republic', 'SY'],
        ['Taiwan', 'TW'],
        ['Tajikistan', 'TJ'],
        ['Tanzania, United Republic of', 'TZ'],
        ['Thailand', 'TH'],
        ['Timor-Leste', 'TL'],
        ['Togo', 'TG'],
        ['Tokelau', 'TK'],
        ['Tonga', 'TO'],
        ['Trinidad and Tobago', 'TT'],
        ['Tunisia', 'TN'],
        ['Turkey', 'TR'],
        ['Turkmenistan', 'TM'],
        ['Turks and Caicos Islands', 'TC'],
        ['Tuvalu', 'TV'],
        ['Uganda', 'UG'],
        ['Ukraine', 'UA'],
        ['United Arab Emirates', 'AE'],
        ['United Kingdom of Great Britain and Northern Ireland', 'GB'],
        ['United States Minor Outlying Islands', 'UM'],
        ['Uruguay', 'UY'],
        ['Uzbekistan', 'UZ'],
        ['Vanuatu', 'VU'],
        ['Venezuela', 'VE'],
        ['Viet Nam', 'VN'],
        ['Virgin Islands (British)', 'VG'],
        ['Virgin Islands (U.S.)', 'VI'],
        ['Wallis and Futuna', 'WF'],
        ['Western Sahara', 'EH'],
        ['Yemen', 'YE'],
        ['Zambia', 'ZM'],
        ['Zimbabwe', 'ZW'],
        ['\u00c5land Islands', 'AX']
    ].map((a) => { return { label: a[0], value: a[1] }; }));
}

function createServiceAutocomplete(el, binding, vnode) {
    var service = binding.value;
    const ac = new Autocomplete(el, Object.assign({
        maximumItems: 10,
        threshold: 1,
        matchall: true,
        onInput: function (value) {
            let self = this;
            if (event.inputType?.startsWith('delete')) { return; }
            if (event.detail && event.detail.selected) { return; }
            service.search(value, (data) => {
                ac.setData(data, true);
                let i = value.length;
                let lcase = value.toLowerCase();
                var v = self.data.find(e => {
                    return e[self.label].toLowerCase().indexOf(lcase) == 0;
                }, self);
                if (v && service.options.typeahead !== false) {
                    let text = v[self.label];
                    window.requestAnimationFrame(() => {
                        el.value = text;
                        el.setSelectionRange(i, text.length, 'backward');
                        self.itemHighlighted = v;
                    });
                }
            });
        },
        onSelectItem: function (item) {
            vnode.elm.value = item[this.label];
            vnode.elm.dispatchEvent(new CustomEvent('input', { detail: { value: vnode.elm.value, selected: true } }));
        },
    }, service.options || {}));
    service.search('', (data) => {
        ac.setData(data, true);
    });
}

const autolist = {
    mounted(el, binding, vnode) {
        if (binding.modifiers.service) {
            createServiceAutocomplete(el, binding, vnode);
        } else {
            switch (binding.value) {
                case 'country':
                    createCountryAutocomplete(el, vnode);
                    break;
            }
        }
    },
};

export { Autocomplete, autolist };
